import { render, staticRenderFns } from "./r-guard-money-rule-dialog.vue?vue&type=template&id=2a547218&scoped=true"
import script from "./r-guard-money-rule-dialog.vue?vue&type=script&lang=js"
export * from "./r-guard-money-rule-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-guard-money-rule-dialog.vue?vue&type=style&index=0&id=2a547218&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a547218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a547218')) {
      api.createRecord('2a547218', component.options)
    } else {
      api.reload('2a547218', component.options)
    }
    module.hot.accept("./r-guard-money-rule-dialog.vue?vue&type=template&id=2a547218&scoped=true", function () {
      api.rerender('2a547218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/guard/r-guard-money-rule-dialog.vue"
export default component.exports